import { useState } from "react";

import { Button } from "@/components/ui/button";

import { DownloadAppUI } from "../Download/DownloadAppUI";

export interface DownloadAppOrContinueOnWebProps {
  continueOnWeb: () => void;
}

export const DownloadAppOrContinueOnWeb = ({
  continueOnWeb,
}: Readonly<DownloadAppOrContinueOnWebProps>) => {
  const [displayApps, setDisplayApps] = useState(false);
  return (
    <div className="flex flex-col space-y-4 p-4 text-left">
      {displayApps ? (
        <DownloadAppUI />
      ) : (
        <ChooseToDownloadApp choose={() => setDisplayApps(true)} />
      )}
      <div>
        <Button
          variant="secondary"
          onClick={() => {
            continueOnWeb();
          }}
          className="btn btn-secondary"
          data-test="continue-web-button"
        >
          Continue on Web
        </Button>
      </div>
    </div>
  );
};

const ChooseToDownloadApp = ({ choose }: { choose: () => void }) => {
  return (
    <>
      <h1 className="text-lg font-medium">Frontier AI</h1>
      <p className="text-sm text-gray-400">
        To get the best experience, download our Mac desktop app.
      </p>
      <div className="mt-4 flex space-x-4">
        <Button onClick={() => choose()}>Get the Mac app</Button>
      </div>
    </>
  );
};
